import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import MostPopularJobSelectJobDropDownIcon from "../../../UI/MostPopularJobSelectJobDropDownIcon";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
import SaveJobIcon from "../../../UI/SaveJobIcon";
import PopularJobCard from "./PopularJobCard";
import SectionHeadingButton from "../WeHelpJobSeekers/SectionHeadingButton";
import SectionHeading from "./SectionHeading";
import SectionsSecondaryHeading from "./SectionsSecondaryHeading";
const cards = [1, 2, 3, 4, 5, 6, 7, 8];
function MostPopularJobSection() {
  return (
    <Stack sx={{ alignItems: "center" }}>
      <SectionHeading>Most Popular Job in</SectionHeading>
      <FormControl
        variant="standard"
        sx={{
          //   minWidth: 250,
          pb: "20px",
          pt: "10px",
          "& .MuiInputBase-root::before": {
            borderBottom: "4px solid #000000",
          }, // Removes bottom border
          "& .MuiInputBase-root::after": {
            borderBottom: "4px solid #000000",
          }, // Removes focus border
          "& .MuiInputBase-root:hover:not(.Mui-disabled)::before": {
            borderBottom: "2px solid #000000",
          }, // Removes hover border
          "& .MuiSelect-select": {
            backgroundColor: "transparent",
            color: "#000000",
            fontFamily: "Inter",
            borderBottom: "2px solid #000000",
          }, // Keeps background clean
          "& .MuiSelect-select.Mui-selected": {
            color: "#000000",
            fontFamily: "Inter",
            borderBottom: "2px solid #000000",
            backgroundColor: "#FFD700 !important", // Custom highlight color when selected
          },
          "& .MuiOutlinedInput-notchedOutline": { border: "2px solid #000000" }, // Ensures no outline
        }}
      >
        <Select
          id="demo-simple-select-helper"
          displayEmpty
          defaultValue="" // Ensures placeholder is shown initially
          IconComponent={() => (
            <Box
              component="img"
              src="/icons/selectIcon.svg"
              sx={{ width: 24, height: 24 }}
            />
          )}
          inputProps={{ "aria-label": "Select Category" }}
          sx={{
            fontSize: "40px",
            fontWeight: "700",
            fontFamily: "Inter",
            color: "#000000",
          }}
        >
          <MenuItem value="" disabled>
            <em>Select Job</em> {/* Placeholder text */}
          </MenuItem>
          <MenuItem value={10}>UI Designer</MenuItem>
          <MenuItem value={20}>UI Developer</MenuItem>
          <MenuItem value={30}>Android Developer</MenuItem>
        </Select>
      </FormControl>
      <SectionsSecondaryHeading color="#878599">
        Find the best paying jobs based on the job category. 100% safe
        recruitment process with transparent progress and real-time assessment.
      </SectionsSecondaryHeading>
      <Stack
        direction="row"
        id="jobs-cards"
        sx={{
          gap: "24px",
          flexWrap: "wrap",
          justifyContent: "center",
          py: "50px",
        }}
      >
        {cards.map((card) => (
          <PopularJobCard />
        ))}
      </Stack>
      <SectionHeadingButton>View all Popular Jobs</SectionHeadingButton>
    </Stack>
  );
}

export default MostPopularJobSection;
